const ballImages= [
  { name: 'White Shapes', img: '/assets/textures/students/3dsquares.png' },
    { name: 'Flowers on Glass', img: '/assets/textures/students/floweryglass.png' },
    { name: 'Grass', img: '/assets/textures/students/grass-large.png' },
    { name: 'Heavy Duty', img: '/assets/textures/students/stone.png' },
    { name: 'Wood', img: '/assets/textures/students/andrew-collins-1616.png' },
    { name: 'Dreams', img: '/assets/textures/students/billy-huynh-278252.png' },
    { name: 'Life', img: '/assets/textures/students/joel-filipe-200538.png' },
    { name: 'Dreams', img: '/assets/textures/students/lyndsey-b-35202.png' },
    { name: 'Sleuth', img: '/assets/textures/students/net.png' },
    { name: 'Universe', img: '/assets/textures/students/octavian-rosca-208933.png' },
    { name: 'Night', img: '/assets/textures/students/paul-volkmer-135317.png' },
    { name: 'Vision', img: '/assets/textures/students/silvio-kundt-65518.png' },
];

export default ballImages;



// WEBPACK FOOTER //
// ./app/components/balls.jsx